export default "__VITE_ASSET__Ct0eIbti__"